// extracted by mini-css-extract-plugin
export var quantityInput = "_q5-0";